import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["accessibilityLabelCloseButton", "disabled", "disabledDays", "inline", "modifiers", "month", "onCalendarChange", "onChange", "onClose", "onMonthChange", "popper", "setPopperElement", "value"];

/* eslint-disable react/forbid-prop-types */
import React, { forwardRef, useRef } from 'react';
import cx from 'classnames';
import Calendar from '../../Calendar';
import Paper from '../../Paper';
import ResponsiveBackdrop from '../ResponsiveBackdrop';
import Screenreader from '../../Screenreader';
import Portal from '../../Portal';
import { useFocusTrap, useBodyScrollLock, useMediaQuery } from '../../../hooks';
import styles from './index.module.scss';
var CalendarDialog = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var accessibilityLabelCloseButton = _ref.accessibilityLabelCloseButton,
      disabled = _ref.disabled,
      disabledDays = _ref.disabledDays,
      inline = _ref.inline,
      modifiers = _ref.modifiers,
      month = _ref.month,
      onCalendarChange = _ref.onCalendarChange,
      onChange = _ref.onChange,
      onClose = _ref.onClose,
      onMonthChange = _ref.onMonthChange,
      popper = _ref.popper,
      setPopperElement = _ref.setPopperElement,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Wrapper = !inline ? Portal : React.Fragment;
  var paperRef = useRef(null);
  var calendarRef = useRef(null); // On mobile we use a modal

  var isMobile = useMediaQuery({
    md: false
  }, true);
  var isDesktop = !isMobile; // On mobile we use a modal

  var popperStyles = !inline && isDesktop ? _extends({
    zIndex: 800
  }, popper.styles.popper) : {};
  useFocusTrap(paperRef.current, !inline, {
    escapeDeactivates: true,
    returnFocusOnDeactivate: true,
    onDeactivate: onClose,
    initialFocus: calendarRef.current
  });
  useBodyScrollLock(!inline && isMobile);
  return /*#__PURE__*/React.createElement(Wrapper, {
    ref: ref
  }, !inline && /*#__PURE__*/React.createElement(ResponsiveBackdrop, {
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    style: popperStyles,
    ref: setPopperElement
  }, /*#__PURE__*/React.createElement(Paper, {
    "aria-label": "dialog",
    "aria-modal": "true",
    className: cx((_cx = {}, _cx[styles.container] = !inline && isMobile, _cx[styles.paper] = true, _cx)),
    display: "inline-block",
    elevation: 2,
    my: 2,
    ref: paperRef,
    role: "dialog",
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(Calendar, _extends({
    disabled: disabled,
    month: month,
    disabledDays: disabledDays,
    onMonthChange: onMonthChange,
    value: value,
    onChange: onChange,
    modifiers: modifiers,
    ref: calendarRef
  }, rest))), !inline && /*#__PURE__*/React.createElement(Screenreader, {
    as: "button",
    onClick: onClose
  }, accessibilityLabelCloseButton)));
});
CalendarDialog.defaultProps = {
  inline: false,
  accessibilityLabelCloseButton: 'Close Datepicker'
};
export default CalendarDialog;